<template>
  <div v-if="typeof delegationDecision.calculations !== 'undefined'">
    <div class="mb-2">
      <h2>{{ $t("delegation.decision.summary") }}</h2>
    </div>
    <div>
      <strong>{{ $t("delegation.decision.status") }}:</strong>
      <delegation-status-chip :status="delegationDecision.status" />
    </div>
    <div v-if="$store.state.Auth.userProperties == null || $store.state.Auth.userProperties.system_settings.cost_centre_on_delegations !== 3">
      <strong>{{ $t("delegationOrder.decision.costCentre") }}: </strong>
      {{ delegationDecision.cost_centre == null ? $t("global.notSet") : delegationDecision.cost_centre.name }}
    </div>
    <div>
      <strong>{{ $t("delegation.decision.delegated") }}: </strong>{{ delegationDecision.user_name }} ({{ delegationDecision.user_login }})
    </div>
    <div>
      <strong>{{ $t("delegation.decision.destination") }}:</strong>
      {{ delegationDecision.destinationText }}
    </div>
    <div v-if="delegationDecision.task_name !== null && delegationDecision.task_name !== ''">
      <strong>{{ $t("delegation.decision.task") }}:</strong>
      {{ $i18n.locale === "pl" || delegationDecision.task_name_en == null ? delegationDecision.task_name : delegationDecision.task_name_en }}
    </div>
    <div v-if="delegationDecision.task != null && delegationDecision.task.length > 0">
      <strong>{{ $t("delegation.decision.taskDescription") }}:</strong>
      {{ delegationDecision.task }}
    </div>
    <div v-if="delegationDecision.external_customer_name != null && delegationDecision.external_customer_name.length > 0">
      <strong>{{ $t("delegation.form.fields.externalCustomer.name") }}:</strong>
      {{ delegationDecision.external_customer_name }}
    </div>
    <div v-if="delegationDecision.project_name != null && delegationDecision.project_name.length > 0">
      <strong>{{ $t("delegation.form.fields.project.name") }}:</strong>
      {{ delegationDecision.project_name }}
    </div>
    <div>
      <strong>{{ $t("delegation.decision.startDate") }}:</strong>
      {{ delegationDecision.start_date }}
    </div>
    <div>
      <strong>{{ $t("delegation.decision.endDate") }}:</strong>
      {{ delegationDecision.end_date }}
    </div>

    <div class="my-2">
      <h2>{{ $t("delegation.decision.costs") }}</h2>
    </div>
    <div v-if="delegationDecision.calculations.isValidTransportType === 0">
      <span>
        <b class="red--text">{{ $t("delegation.decision.transportOtherThanDelegationOrder") }} </b>
      </span>
    </div>
    <div>
      {{ $t("delegation.decision.transportCost") }}:
      <span
        ><b
          v-bind:class="{
            'green--text': delegationDecision.calculations.isValidTransportLimit,
            'red--text': !delegationDecision.calculations.isValidTransportLimit
          }"
          >{{ delegationDecision.calculations.transportCost.toFixed(2) }}</b
        ></span
      >
      <span class="red--text" v-if="!delegationDecision.calculations.isValidTransportLimit"
        ><b> ({{ $t("global.error.transportLimitExceeded") }})</b></span
      >
    </div>
    <div>
      {{ $t("delegation.decision.accommodationCost") }}:
      <span
        ><b
          v-bind:class="{
            'green--text': !accommodationCostExceeded,
            'red--text': accommodationCostExceeded
          }"
          >{{ delegationDecision.calculations.accommodationCost.toFixed(2) }}</b
        ></span
      >
      <span class="red--text" v-if="accommodationCostExceeded"
        ><b> ({{ $t("global.error.hotelLimitExceeded") }})</b></span
      >
    </div>
    <div>
      {{ $t("delegation.decision.dietCost") }}:
      <span
        ><b class="green--text">{{ delegationDecision.calculations.countryCost.toFixed(2) }}</b></span
      >
    </div>
    <div>
      {{ $t("delegation.decision.otherCost") }}:
      <span
        ><b class="green--text">{{ delegationDecision.calculations.otherCost.toFixed(2) }}</b></span
      >
    </div>
    <div>
      {{ $t("delegation.decision.advance") }}:
      <span
        ><b class="green--text">{{ delegationDecision.calculations.payedAdvances.toFixed(2) }}</b></span
      >
    </div>
    <div>
      <strong>{{ $t("delegation.decision.returnToDelegated") }}: </strong>
      <span>
        <b class="green--text">{{ delegationDecision.calculations.returnToWorkerCost.toFixed(2) }}</b>
      </span>
    </div>

    <v-btn :disabled="$store.getters['Ajax/loading']" @click="downloadSettlement" class="primary mx-2">{{
      $t("delegation.decision.downloadSettlement")
    }}</v-btn>
    <v-btn :disabled="$store.getters['Ajax/loading']" @click="downloadAttachments" class="primary mx-2"
      >{{ $t("delegation.decision.downloadAllAttachments") }}
    </v-btn>
    <v-btn class="primary mx-2" :to="'/delegation/readonly/' + delegationDecision.id">{{ $t("delegation.viewReadonly") }}</v-btn>

    <h2>{{ $t("delegation.decision.acceptanceHistory") }}</h2>
    <div>
      {{ $t("delegation.decision.created") }} {{ $t("global.at") }} {{ delegationDecision.created_at }} {{ $t("global.by") }}
      {{ delegationDecision.created_by_name }}
      ({{ delegationDecision.created_by_login }}).
    </div>
    <!-- eslint-disable-next-line -->
    <span v-for="historyItem in delegationDecision.history">{{ historyItem }} <br /></span>

    <div v-if="delegationDecision.status === 2 && delegationDecision.hasPermissionForSubstantialDecision">
      <h2>
        {{ $t("delegation.decision.hasPermissionForSubstantialDecision") }}
      </h2>
      <v-row class="text-center">
        <v-spacer />
        <!--                <v-flex :class="{'border-positive': delegationDecision.accepted_by_id!=null}" class="choose-box elevation-5 " md4 vertical-align xs12>-->
        <v-col class="choose-box elevation-5  vertical-align" md="4" cols="12">
          <h3>{{ $t("delegation.decision.positive.title") }}</h3>
          <v-icon size="75px">fa-check</v-icon>
          <p>
            {{
              this.delegationDecision.accepted_by_id == null
                ? $t("delegation.decision.positive.description.substantial")
                : $t("delegation.decision.positive.description.substantialAlready")
            }}
          </p>
          <br /><br />
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="accept()" bottom>{{ $t("delegation.decision.positive.acceptButton") }}</v-btn>
        </v-col>
        <v-spacer />
        <!--                <v-flex :class="{'border-negative': delegationDecision.rejected_at!=null}" class="choose-box elevation-5" md4-->
        <!--                        xs12>-->
        <v-col class="choose-box elevation-5" md="4" cols="12">
          <h3>{{ $t("delegation.decision.negative.title") }}</h3>
          <v-icon size="75px">fa-ban</v-icon>
          <p>
            {{ $t("delegation.decision.negative.description.substantial") }}
          </p>
          <br />
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="deny()" bottom>{{ $t("delegation.decision.negative.denyButton") }}</v-btn>
          <br />
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="denyAndRevert()" bottom>
            {{ $t("delegation.decision.negative.denyAndRevertButton") }}
          </v-btn>
        </v-col>
        <v-spacer />
      </v-row>
    </div>
    <div v-if="delegationDecision.hasPermissionForFinancialDecision && delegationDecision.status === 3">
      <h2>{{ $t("delegation.decision.hasPermissionForFinancialDecision") }}</h2>
      <v-row class="text-center">
        <v-spacer />
        <v-col :class="{ 'border-positive': delegationDecision.settled_at != null }" class="choose-box elevation-5  vertical-align" md="4" cols="12">
          <h3>{{ $t("delegation.decision.positive.title") }}</h3>
          <v-icon size="75px">fa-check</v-icon>
          <p>
            {{
              delegationDecision.settled_at == null
                ? $t("delegation.decision.positive.description.financial")
                : $t("delegation.decision.positive.description.financialAlready")
            }}
          </p>
          <br /><br />
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="settle()" bottom>{{ $t("delegation.decision.positive.acceptButton") }}</v-btn>
        </v-col>
        <v-spacer />
        <v-col class="choose-box elevation-5" md="4" cols="12">
          <h3>{{ $t("delegation.decision.negative.title") }}</h3>
          <v-icon size="75px">fa-ban</v-icon>
          <p>
            {{ $t("delegation.decision.negative.description.financial") }}
          </p>
          <br />
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="deny()" bottom>{{ $t("delegation.decision.negative.denyButton") }}</v-btn>
          <br />
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="denyAndRevert()" bottom>
            {{ $t("delegation.decision.negative.denyAndRevertButton") }}
          </v-btn>
        </v-col>
        <v-spacer />
      </v-row>
    </div>
  </div>
</template>

<script>
import DelegationStatusChip from "./DelegationStatusChip";

export default {
  name: "DelegationDecisionForm",
  components: { DelegationStatusChip },
  data: () => ({}),
  props: {
    delegationDecision: {
      required: true
    }
  },
  created() {},
  computed: {
    contextDelegationDecision: {
      get() {
        return this.delegationDecision;
      },
      set(value) {
        this.$emit("update:delegationDecision", value);
      }
    },
    accommodationCostExceeded() {
      if (this.delegationDecision == null) {
        return false;
      }
      for (let country of this.delegationDecision.calculations.isValidHotelLimit) {
        for (let isValidHotelLimit of country) {
          if (!isValidHotelLimit) return true;
        }
      }
      return false;
    },
    transportCostExceeded() {
      if (this.delegationDecision != null) {
        return false;
      }
      return !this.$store.state.Delegation.delegationCalculation.isValidTransportLimit;
    }
  },
  methods: {
    downloadSettlement() {
      this.$emit("downloadSettlement");
    },
    downloadAttachments() {
      this.$emit("downloadAllFiles");
    },
    accept() {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("components.actions.delegation.acceptConfirm.content"),
        title: this.$t("components.actions.delegation.acceptConfirm.title")
      });
      result.then(() => {
        this.$emit("accept");
      });
    },
    settle() {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("components.actions.delegation.acceptConfirm.content"),
        title: this.$t("components.actions.delegation.acceptConfirm.title")
      });
      result.then(() => {
        this.$emit("settle");
      });
    },
    deny() {
      let result = this.$store.dispatch("promptDialog", {
        content: this.$t("components.actions.delegation.rejectConfirm.content"),
        title: this.$t("components.actions.delegation.rejectConfirm.title"),
        label: this.$t("delegation.decision.reason"),
        //rules: [v=>(v!=null&&v.length>0)||'Pole wymagane'],
        textarea: true
      });
      result.then(promptText => {
        this.$emit("deny", promptText);
      });
    },
    denyAndRevert() {
      let result = this.$store.dispatch("promptDialog", {
        content: this.$t("components.actions.delegation.rejectAndBackConfirm.content"),
        title: this.$t("components.actions.delegation.rejectAndBackConfirm.title"),
        label: this.$t("delegation.decision.reason"),
        //rules: [/*v=>(v!=null&&v.length>0)||'Pole wymagane'*/],
        textarea: true
      });
      result.then(promptText => {
        this.$emit("denyAndRevert", promptText);
      });
    }
  }
};
</script>

<style scoped></style>
